import { useEffect } from 'react';

import { useCurrentAccount } from '@adsk/alloy-provider';

import { useIdleTimer } from '../providers/IdleTimerProvider';

export const IdleTimerCurrentAccountListener = () => {
  const { update } = useIdleTimer();
  const currentAccount = useCurrentAccount();

  const enabled = currentAccount?.idle_timeout?.enabled === true;
  const duration = currentAccount?.idle_timeout?.duration;
  const isLoading = currentAccount === undefined;

  useEffect(() => {
    if (!isLoading) {
      update({ timeoutMs: enabled ? duration : undefined });
    }
  }, [duration, enabled, isLoading, update]);

  return null;
};
